import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import Sidebar from './blocks/Sidebar.tsx';
import Header from './blocks/Header.tsx';
import '../styles/scss/DashboardLayout.scss';

export default function DashboardLayout() {
  return (
    <Box className="dashboard-layout">
      <Sidebar />
      <Box component="main" className="dashboard-main">
        <Header />
        <Box className="dashboard-content">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
